import React, { useContext, useState } from "react";
import GlobalContext from "../../../contexts/globalContext";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import CardPayHomeMobile from "../../molecules/card-rates-home-mobile/card-rates-home-mobile";
import CardPayHome from "../../molecules/card-rates-home/card-rates-home";
import "./services-payed.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import DownloadModal from "../../molecules/download-modal/downloadModal";

const ServicesPayed = (props: ReferenciaContenido) => {
  const data = [props];
  const dataContext = useContext(GlobalContext);
  const { nombreCategoria } = props;
  const dataModal = data[0]?.referenciaTabsContenido?.[0];
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  return (
    <div>
      {(nombreCategoria === "Home" &&
        dataContext.userInfoContext.data?.userHaveTransaction === false) ||
      (nombreCategoria === "Home" &&
        dataContext.userInfoContext.data?.userHaveTransaction === undefined) ? (
        ""
      ) : (
        <div>
          <div className="m-services-payed">
            <h2
              className={`m-services-payed-title title-secondary ${
                nombreCategoria === "Empresas" ? "enterprises" : ""
              }`}
            >
              {props.tituloGeneral}
            </h2>
            {nombreCategoria === "Empresas" ? (
              <p className="m-services-payed-desc">
                {
                  JSON.parse(data[0].descripcion.raw).content[0].content[0]
                    .value
                }
              </p>
            ) : (
              ""
            )}
            <div className="m-services-payed-cards hide-on-mobile">
              <CardPayHome datas={data} />
            </div>
            {nombreCategoria === "Empresas" ? (
              <>
                <DownloadModal
                  isOpen={isJoinOpen}
                  setIsOpen={setIsJoinOpen}
                  data={dataModal}
                />
                <div className="m-services-payed-button hide-on-mobile">
                  <Button
                    type="button"
                    text={data[0].tituloBoton}
                    classname={`primary`}
                    gtmMark={`gtm${nombreCategoria}${normalizeTwoWords(
                      props.tituloGeneral
                    )}`}
                    isDisabled={false}
                    onClickAction={() => setIsJoinOpen(true)}
                    // href={data[0].redireccionBoton}
                  />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="m-services-payed-mobile show-on-mobile">
            <CardPayHomeMobile datas={data} />
          </div>
          {nombreCategoria === "Empresas" ? (
            <>
              <DownloadModal
                isOpen={isJoinOpen}
                setIsOpen={setIsJoinOpen}
                data={dataModal}
              />
              <div className="m-services-payed-buttonMobile">
                <Button
                  type="button"
                  text={data[0].tituloBoton}
                  classname={`primary`}
                  gtmMark={`gtm${nombreCategoria}${normalizeTwoWords(
                    props.tituloGeneral
                  )}`}
                  isDisabled={false}
                  onClickAction={() => setIsJoinOpen(true)}
                  // href={data[0].redireccionBoton}
                />
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default ServicesPayed;
